import { css } from '@emotion/css';
import React, { HTMLAttributes } from 'react';

type MiniRibbonProps = {
  textColor: string;
  backgroundColor: string;
} & HTMLAttributes<HTMLDivElement>;

export const MiniRibbon: React.FC<MiniRibbonProps> = ({
  textColor,
  backgroundColor,
  children,
  ...rest
}) => {
  const ribbonSideImage = getRibbonSideImage(backgroundColor);

  return (
    <div
      className={css`
        display: inline-block;
        color: ${textColor};
        position: relative;
        padding: 2px 4px;
        background: ${backgroundColor};
        &::before,
        &::after {
          content: '';
          position: absolute;
          width: 8px;
          top: 0;
          bottom: 0;
          background: url('${ribbonSideImage}');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        &::before {
          left: -7px;
          transform: scaleX(-1);
        }
        &::after {
          right: -7px;
        }
      `}
      {...rest}
    >
      {children}
    </div>
  );
};

function getRibbonSideImage(color: string) {
  const encoded = encodeURIComponent(color);
  return `data:image/svg+xml,%3Csvg width="8" height="24" preserveAspectRatio="none" viewBox="0 0 8 24" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M5.338 24H0V0h5.338c1.835 0 3.121 1.827 2.507 3.568l-2.653 7.538a2.704 2.704 0 000 1.784l2.653 7.537C8.459 22.174 7.173 24 5.338 24z" fill="${encoded}"/%3E%3C/svg%3E`;
}
